export default __webpack_public_path__ + "static/media/bg_map_1.75993604.png";